import Vue from 'vue';
import VueBootstrap from 'bootstrap-vue';
import VueAxios from 'vue-axios';
import VueMoment from 'vue-moment';
import VueSocketIO from 'vue-socket.io';
import axios from 'axios';
import numFormat from 'vue-filter-number-format';
import VueMobileDetection from "vue-mobile-detection";
import VCalendar from 'v-calendar';
import $ from 'jquery'

import App from './App.vue';
import store from './store';
import routes from './routes';
import token from './libs/boogr-token';

Vue.filter('numFormat', numFormat);

Vue.use(VueBootstrap);
Vue.use(VueMoment);
Vue.use(VueAxios, axios);
Vue.use(VCalendar);
Vue.use(VueMobileDetection);

import statusAprroval from '../src/components/statusApproval.vue'
Vue.component('statusAprroval',statusAprroval);

// Vue.use(new VueSocketIO({
//     debug: true,
//     connection: process.env.VUE_APP_BASE_API_NOPREFIX,
//     vuex: {
//         store,
//         actionPrefix: 'SOCKET_',
//     },
//     options: {
//         secure: true,
//         reconnect: true,
//         rejectUnauthorized: false        
//     }
// }));
Vue.use(new VueSocketIO({
    debug: false,
    connection: process.env.VUE_APP_BASE_API_NOPREFIX,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
    }, 
    options: { path: '/socket.io'}
}));

axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
axios.defaults.headers['Content-type'] = 'application/json';

global.Vue = Vue;

(async () => {
    token.validate();
    const router = await routes.instance();
    return new Vue({
        router,
        store,
        render: h => h(App),
        created: function () {
            token.refresh(1000 * 60 * 30);
            window.router = router;
        }
    }).$mount('#app');
})();

window._store = store;
